import React from "react";

export default function NavLinkWrapper({ children }) {
  return (
    <div className="nav-item border-t hover:border-t-black pt-1   hover:pr-0 flex gap-4 items-center duration-300 ">
      {children}
    </div>
  );
}
